import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAppState } from '../hooks';
import { HomeCard } from './index';
import { ReactComponent as IconAssist } from '../assets/iconAA.svg';

function AgentAssistHomeCard(props) {
  const { history } = props;
  const { features } = useAppState();
  const isMounted = useRef(false);
  const [buttons, setButtons] = useState([]);
  const [content, setContent] = useState('');

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const isAgentAssistEnabled = features?.['maven.agentassist.enabled'];
      if (isAgentAssistEnabled) {
        setButtons([
          { name: 'Bot Recommendations', route: '/recommended-actions' },
          { name: 'Knowledge Base', route: '/knowledge-base' },
        ]);
        setContent('Agent Assist recommends knowledge base articles and bots to agents based on the intent detected in the consumer message.');
      } else {
        setButtons([]);
        setContent('Agent Assist is now called Conversation Assist. Access Conversation Assist from the Conversational AI applications page.');
      }
    }
  }, [features]);

  return (
    <HomeCard
      title="Agent Assist"
      history={history}
      Icon={IconAssist}
      content={content}
      buttons={buttons}
    />
  );
}

AgentAssistHomeCard.defaultProps = {};

AgentAssistHomeCard.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AgentAssistHomeCard;
